<template src="../templates/privilege-item.html"></template>

<script>
export default {
  name: 'PrivilegeItem',
  props: {
    item: {
      type: Object,
      default: () => null,
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
